export default __webpack_public_path__ + "static/media/Image_OB_EditDash@3x.fe2c18e3.png";